'use client';

import { FULL_SCREEN_PATHS } from '@baseball-near-you/common';
import { Toaster } from '@baseball-near-you/ui';
import { tryGetCurrentClientUser } from '@bb/lib/session/client';
import {
  QueryClient,
  QueryClientProvider,
  isServer,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { usePathname, useRouter } from 'next/navigation';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { Fragment, useEffect } from 'react';

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
  if (isServer) {
    // Server: always make a new query client
    return makeQueryClient();
  }
  // Browser: make a new query client if we don't already have one
  // This is very important, so we don't re-make a new client if React
  // suspends during the initial render. This may not be needed if we
  // have a suspense boundary BELOW the creation of the query client
  if (!browserQueryClient) browserQueryClient = makeQueryClient();
  return browserQueryClient;
}

export default function Providers({
  children,
}: {
  children: React.ReactNode;
}) {
  const queryClient = getQueryClient();

  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    tryGetCurrentClientUser().then((user) => {
      if (user) {
        if (
          !user?.completedOnboarding &&
          !pathname.includes(FULL_SCREEN_PATHS.Onboarding)
        ) {
          router.push(FULL_SCREEN_PATHS.Onboarding);
        }
        if (
          !!user.completedOnboarding &&
          pathname.includes(FULL_SCREEN_PATHS.Onboarding)
        ) {
          // router.push('/');
        }
      }
    });
  }, []);

  return (
    <Fragment>
      <QueryClientProvider client={queryClient}>
        <PostHogProvider client={posthog}>{children}</PostHogProvider>
        <ReactQueryDevtools position="bottom-right" initialIsOpen={false} />
      </QueryClientProvider>
      <Toaster richColors />
    </Fragment>
  );
}
